import React from 'react'
import type { JSX } from 'react'
import { cn } from '@/lib/utils'

interface AppShellProps {
  header?: React.ReactNode
  sidebar?: React.ReactNode
  children: React.ReactNode
  className?: string
}

export const AppShell = ({ header, sidebar, children, className }: AppShellProps): JSX.Element => {
  return (
    <div className={cn('min-h-screen bg-background', className)}>
      {header}
      <div className="flex">
        {sidebar}
        <main className="flex-1 min-w-0 min-h-[calc(100vh-3.5rem)]">
          {children}
        </main>
      </div>
    </div>
  )
}
